// extracted by mini-css-extract-plugin
export default {"editButton":"hrRelease_editButton__IVQxv","TableBody":"hrRelease_TableBody__LTQms","StopButton":"hrRelease_StopButton__KRSCt"};